import * as React from 'react';
import { Head } from '@inertiajs/react';

interface Props {
  appUrl: string;
}

export function SEOBlock({ appUrl }: Props) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Abasto Virtual',
    description:
      'Delivery de frutas y verduras frescas en Córdoba para que puedas hacerle el mandado a un familiar. Pedido online, entrega en el día y la franja horaria que elijas.',
    url: `${appUrl}/seres-queridos`,
    telephone: '+5493512026384',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Córdoba',
      addressRegion: 'Córdoba',
      addressCountry: 'AR',
    },
    areaServed: {
      '@type': 'City',
      name: 'Córdoba',
    },
    priceRange: '$$',
  };

  return (
    <>
      <Head>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Head>
      <section className="sq-seo">
        <style>{`
          .sq-seo {
            padding: 48px 24px;
            background: #fafaf7;
            border-top: 1px solid #eee;
          }
          .sq-seo-inner {
            max-width: 720px;
            margin: 0 auto;
          }
          .sq-seo h2 {
            font-size: 20px;
            font-weight: 700;
            color: #666;
            margin: 0 0 12px;
          }
          .sq-seo p {
            font-size: 15px;
            color: #888;
            line-height: 1.7;
            margin: 0;
          }
        `}</style>
        <div className="sq-seo-inner">
          <h2>Hacerle el mandado a un familiar en Córdoba</h2>
          <p>
            Abasto Virtual entrega frutas y verduras frescas en Córdoba capital y alrededores.
            Podés guardar varias direcciones en una misma cuenta, elegir el día y la franja
            horaria de entrega y pagar online, para que quien recibe el pedido no tenga que
            salir ni resolver el pago en la puerta.
          </p>
        </div>
      </section>
    </>
  );
}
